import { inject, Injectable, NgZone } from '@angular/core';
import { EventsManagerService } from '@core/events-manager/events-manager.service';
import { INTER_APP_CONSTANTS } from '@core/legacy/inter-app.constants';
import { NavigationService } from '@core/navigation/navigation.service';

@Injectable({
	providedIn: 'root',
})
export class OrdersEventService {
	eventsManagerService = inject(EventsManagerService);
	navigationService = inject(NavigationService);
	private ngZone = inject(NgZone);

	subscribeToEvents() {
		this.eventsManagerService.subscribe(INTER_APP_CONSTANTS.REV360.ORDERS.OPEN_ORDER_FROM_SUMMARY_POD, async (event) =>
			this.ngZone.run(
				() => this.navigationService.navigateToOrder(event.argument.orderId),
			),
		);
	}
}
